var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.25 90.03"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    "data-name": "001-delete",
    d: "M27.74 5.25h15v2.63H48V5a5 5 0 00-5.07-5H27.2a5.09 5.09 0 00-5.09 5.1v2.78h5.63zm33 24H9.52a2.41 2.41 0 00-2.4 2.6L11.4 84.8a5.7 5.7 0 005.67 5.2h36.11a5.69 5.69 0 005.66-5.23l4.28-52.94a2.4 2.4 0 00-2.39-2.57zM21.93 84.41h-.17A2.73 2.73 0 0119 81.86l-2.64-43.42a2.73 2.73 0 115.44-.34l2.68 43.43a2.72 2.72 0 01-2.55 2.88zm15.93-2.72a2.81 2.81 0 01-5.62-.11V38.36a2.81 2.81 0 015.62-.09zm16-43.26l-2.53 43.42a2.73 2.73 0 01-2.72 2.57h-.16a2.71 2.71 0 01-2.56-2.88l2.55-43.42a2.73 2.73 0 015.45.32zM70.13 21l-1.8-5.48A3.45 3.45 0 0065 13.13H5.19a3.46 3.46 0 00-3.28 2.41L.12 21a2.29 2.29 0 00.94 2.66 2.19 2.19 0 001.19.34H68a2.19 2.19 0 001.19-.35 2.31 2.31 0 00.94-2.65z"
  })))));
}
export default SvgDelete;